import request, {requestJson, requestImage} from '../main';
import { JSEncrypt } from 'jsencrypt';
import axios from "axios";
const service = ""
const publicKey = "-----BEGIN PUBLIC KEY-----\n" +
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArY0q+9uUQNS0MVjyx8NC\n" +
    "UU7/3vjf2D4t6Z1AtRj2jprSU70rXhfXrRZ6VJLSjpQQ1YgSi5nP4CArkOyPSP06\n" +
    "7BzAPdW+6/QZYw6CJWdR+dFjB7qnSLIX26KQWhEpVk2pfoovFcEYp0euIOI8vdod\n" +
    "8dJ2ziciV/FjocDd1LIz2MaPKzW3NeQ8DV90BcTa8Y7SayH94EeJGBjSd7G3Kti1\n" +
    "g0JF8CJxbgMEHT5wFOLFdWfVYBW6B4oN18xVp7aq0YWIO68JBm/e/orqbp9KUZA4\n" +
    "ac05M6WUlLx94evEYtTEyAma0lQl2bt6Xsp0yYQQIi9wu/0gEzsaOfWTfnLQhorG\n" +
    "xwIDAQAB\n" +
    "-----END PUBLIC KEY-----";
async function encryptPassword(password : any) {
    const enc = new JSEncrypt();
    enc.setPublicKey(publicKey);
    return encodeURIComponent(enc.encrypt(password));
}
// const service = "/org-service"
// import cosUtils from "@/common/cosUtils";
// import ossUtils from "@/common/ossUtils";
// import { cloudUpload } from "@/constants";
// class UploadApi{
//     public upload(args: any): Promise<any>{
//         return new Promise<any>((resolve, reject) => {
//             if(cloudUpload == 'OSS'){
//                 ossUtils.put({'file':args.file,'type':args.type,'fileName':args.file.fileName},(res: any)=>{
//                     if(res.data.result == 0){
//                         resolve(res);
//                     }else{
//                         reject(res);
//                     }
//                 });
//             }else{
//                 cosUtils.putObject({'file':args.file,'type':args.type,'fileName':args.file.fileName},(res: any)=>{
//                     if(res.data.result == 0){
//                         resolve(res);
//                     }else{
//                         reject(res);
//                     }
//                 });
//             }
//         });
//     }
// }

class FileApi {
    private url: string = service + "/file";

    //获取图片
    public getTemporaryFile(args: any) {
        return request({
            url: this.url + '/get-temporary-file',
            method: 'get',
            params: args
        })
    }
    //清除图片
    public deleteTemporaryFile(args: any) {
        return request({
            url: this.url + '/delete-temporary-file',
            method: 'post',
            data: args
        })
    }
    //上传图片
    public upload(args: any){
        return requestImage({
            url: this.url + '/upload',
            method: 'post',
            data: args
        })
    }
}
class SsoApi{
    private url: string = service + "/sso";
    //获取登录人列表
    public listUsers(){
        return request({
            url: this.url + '/list-users',
            method: 'get'
        })
    }

    public isExpiredPwd(){
        return request({
            url: this.url + '/is-expired-pwd',
            method: 'get',
        })
    }

    //模拟登录
    public login(data: any){
        return request({
            url: this.url + '/login',
            method: 'post',
            data: data
        })
    }
    //登录
    public async login2(data: any){
        const enc = Object.assign({}, data,
            {
                name: await encryptPassword(data.name),
                pwd: await encryptPassword(data.pwd)
            });
        return request({
            url: this.url + '/login2',
            method: 'post',
            data: enc
        })
    }

    public loginByMobile(mobile: string, code: string, token: string, captchaId: string, captchaMove: string){
        return request({
            url: this.url + '/login-by-mobile',
            method: 'post',
            data: {
                mobile: mobile,
                code: code,
                token: token,
                captchaId: captchaId,
                captchaMove: captchaMove
            }
        })
    }

    public mpLogin(code: string){
        return request({
            url: this.url + '/wx-login',
            method: 'get',
            params:{
                code: code,
                form: "MP"
            }
        })
    }

    public wxLogin(code: string){
        return request({
            url: this.url + '/wx-login',
            method: 'get',
            params:{
                code: code,
                form: "WX"
            }
        })
    }

    public wxBind(data: any){
        return request({
            url: this.url + '/wx-bind',
            method: 'post',
            data: {
                ...data,
                form: "WX"
            }
        })
    }


    public mpBind(data: any){
        return request({
            url: this.url + '/wx-bind',
            method: 'post',
            data: {
                ...data,
                form: "MP"
            }
        })
    }

    public authorize(code: string, m: string){
        return request({
            url: this.url + '/authorize-sj',
            method: 'get',
            params: {
                code: code,
                m : m
            }
        });
    }

    public getWeiXinConfig(url: string){
        return request({
            url: this.url + '/getWeiXinConfig',
            method: 'get',
            params: {
                url:url
            }
        })
    }
    public wxUnBind(){
        return request({
            url: this.url + '/wxUnBind',
            method: 'get',
        });
    }
    public validateMobile(mobile: string , userType: number){
        return request({
            url: this.url + '/validate-mobile',
            method: 'patch',
            data: {
                mobile: mobile,
                userType: userType
            }
        })
    }
    /*教师*/
    public sendSms(mobile: string, ticket: string, randStr: string, token: string, userType: number){
        return request({
            url: this.url + '/send-sms',
            method: 'patch',
            data: {
                mobile: mobile,
                ticket: ticket,
                randStr: randStr,
                token: token,
                userType: userType,
                form: 0
            }
        })
    }
    public validCode(token: string, code: string){
        return request({
            url: this.url + '/validate-code',
            method: 'patch',
            data: {
                code: code,
                token: token
            }
        })
    }
    public resetPwd(token: string, pwd: string){
        return request({
            url: this.url + '/reset-pwd',
            method: 'patch',
            data: {
                pwd: pwd,
                token: token
            }
        })
    }

}

class DictApi{
    private url: string = service + "/dict";
    public list(person: any){
        return request({
            url: this.url + '/list',
            method: 'get',
            params: person
        });
    }
    //省市县树结构
    public treeUnitArea(){
        return request({
            url: this.url + '/tree-unit-area',
            method: 'get',
        });
    }

    public listDictTree(args: any){
        return request({
            url: this.url + '/list-dict-tree',
            method: 'get',
            params: args
        });
    }

    public listGrades(){
        return request({
            url: this.url + '/grades',
            method: 'get'
        });
    }
    public listSchoolGrades(schoolId: number){
        return request({
            url: this.url + '/list-grade-by-school',
            method: 'get',
            params:{
                schoolId: schoolId
            }
        });
    }
    public listSubjects(){
        return request({
            url: this.url + '/subjects',
            method: 'get'
        });
    }
    public listSubjectPackages(){
        return request({
            url: this.url + '/list-subject-package',
            method: 'get'
        })
    }
    //指定学段下的学科
    public listSubjectsBySection(person: any) {
        return request({
            url: '/org-service/dict/subjects-by-section',
            method: 'get',
            params: person
        });
    }

    //行政部门列表
    public listDepartMents(){
        return request({
            url: this.url + '/list_depart_ments',
            method: 'get'
        })
    }

    //查字典
    public listDictItem(args: any){
        return request({
            url: this.url + '/list-dict-item',
            method: 'get',
            params: args
        })
    }

    public listDictSymbol(args: any){
        return request({
            url: this.url + '/list-dict-symbol',
            method: 'get',
            params: args
        })
    }

    public treeRegion(args: any){
        return request({
            url: this.url + '/tree-region',
            method: 'get',
            params: args
        })
    }
    public listRegion(){
        return request({
            url: this.url + '/list-region',
            method: 'get',
        })
    }
    public listDictInstrument(){
        return request({
            url: this.url + '/list-dict-instrument',
            method: 'get',
        })
    }

    public listInstrumentCatalogueTree(){
        return request({
            url: this.url + '/list-instrument-catalogue-tree',
            method: 'get',
        })
    }

    public getWxConfig(url: string){
        return request({
            url: this.url + '/get-wx-config',
            method: 'get',
            params: {
                url: url
            }
        })
    }
    //器具名称添加
    public addInstrument(args: any){
        return requestJson({
            url: this.url + '/add-instrument',
            method: 'post',
            data: args
        })
    }
    //器具名称修改
    public updateInstrumentName(args: any){
        return requestJson({
            url: this.url + '/update-instrument-name',
            method: 'post',
            data: args
        })
    }
    //器具名称删除
    public delInstrumentName(args: any){
        return request({
            url: this.url + '/del-instrument-name',
            method: 'post',
            data: args
        })
    }
    //第四级器具名称列表
    public listDictInstrumentName(args: any){
        return request({
            url: this.url + '/list-dict-instrument-names',
            method: 'get',
            params: args
        })
    }


    public listDictCatalogueTree(){
        return request({
            url: this.url + '/list-dict-catalogue-tree',
            method: 'get',
        })
    }
}

class DictInstrumentApi{
    private url: string = service + "/dictInstrument";
    //器具字典列表
    public list(person: any){
        return request({
            url: this.url + '/list',
            method: 'get',
            params: person
        });
    }
    //查询条件弹出输入提示下拉 1主名称  2别名
    public listDictInstrumentNames(person: any){
        return request({
            url: this.url + '/list-dict-instrument-names',
            method: 'get',
            params: person
        });
    }

    public listDictInstrByParentId(parentId: number){
        return request({
            url: this.url + '/list-dict-instr-by-parent-id',
            method: 'get',
            params: {
                parentId: parentId
            }
        });
    }



    //添加和编辑器具字典
    public addOrUpdateInstrument(person: any){
        return requestJson({
            url: this.url + '/add-or-update-instrument',
            method: 'post',
            data: person
        });
    }
    //根据id获取器具字典详情
    public getOne(person: any){
        return requestJson({
            url: this.url + '/get-one',
            method: 'get',
            params: person
        });
    }
    //器具别名保存
    public changeInstrumentName(person: any){
        return requestJson({
            url: this.url + '/change-instrument-name',
            method: 'post',
            data: person
        });
    }
    //器具名称删除
    public delInstrument(args: any){
        return request({
            url: this.url + '/del-instrument',
            method: 'post',
            data: args
        })
    }
    //器具移动
    public mergeInstrument(args: any){
        return request({
            url: this.url + '/merge-instrument',
            method: 'post',
            data: args
        })
    }
    //器具替换
    public moveInstrument(args: any){
        return request({
            url: this.url + '/move-instrument',
            method: 'get',
            params: args
        })
    }
    //器具移出-拆分
    public splitInstrument(args: any){
        return request({
            url: this.url + '/split-instrument',
            method: 'get',
            params: args
        })
    }


    public updateInstrumentName(args: any){
        return request({
            url: this.url + '/update-instrument-name',
            method: 'get',
            params: args
        })
    }

    public addDictInstrument(args: any){
        return request({
            url: this.url + '/add-dict-instrument',
            method: 'get',
            params: args
        })
    }

    public moveDictInstrument(args: any){
        return request({
            url: this.url + '/move-dict-instrument',
            method: 'get',
            params: args
        })
    }

    public deleteDictInstrument(args: any){
        return request({
            url: this.url + '/delete-dict-instrument',
            method: 'get',
            params: args
        })
    }

    public delInstrumentCatalogue(args: any){
        return request({
            url: this.url + '/del-instrument-catalogue',
            method: 'get',
            params: args
        })
    }

    public moveInstrumentCatalogue(args: any){
        return request({
            url: this.url + '/move-instrument-catalogue',
            method: 'get',
            params: args
        })
    }

    public updateInstrumentCatalogue(args: any){
        return request({
            url: this.url + '/update-instrument-catalogue',
            method: 'get',
            params: args
        })
    }

    public addInstrumentCatalogue(args: any){
        return request({
            url: this.url + '/add-instrument-catalogue',
            method: 'get',
            params: args
        })
    }





}

class ModuleApi{
    private url: string = service + "/module";
    public list(){
        return request({
            url: this.url + '/list',
            method: 'get'
        });
    }
    public pageList(args: any){
        return request({
            url: this.url + '/page-list',
            method: 'get',
            params: args
        });
    }
    public listByUserSchool(){
        return request({
            url: this.url + '/list-by-user-school',
            method: 'get'
        });
    }
    public listBySchool(schoolId: number){
        return request({
            url: this.url + '/list-by-school',
            method: 'get',
            params: {schoolId:schoolId}
        });
    }
    public add(module: any){
        return request({
            url: this.url,
            method: 'post',
            data: module
        });
    }

    public updateById(module: any){
        return request({
            url: this.url + "/update-by-id",
            method: 'post',
            data: module
        });
    }

    public delete(args: any){
        return request({
            url: this.url + "/del-by-id",
            method: 'post',
            data: args
        });
    }
    public getOne(args: any){
        return request({
            url: this.url + '/get-one',
            method: 'get',
            params: args
        });
    }
    public changeOrderIndex(args: any){
        return requestJson({
            url: this.url + "/change-order-index",
            method: 'post',
            data: args
        });
    }
}

class ModuleResourceApi{
    private url: string = service + "/module-resource";
    public treeByModule(moduleId: number){
        return request({
            url: this.url + '/tree-by-module',
            method: 'get',
            params: {moduleId:moduleId}
        });
    }

    public listAll(args: any){
        return request({
            url: this.url + '/list-all',
            method: 'get',
            params: args
        });
    }



    public listByModule(moduleId: number){
        return request({
            url: this.url + '/list-by-module',
            method: 'get',
            params: {moduleId:moduleId}
        });
    }

    public listBySchool(schoolId: number){
        return request({
            url: this.url + '/list-by-school',
            method: 'get',
            params: {schoolId:schoolId}
        });
    }
    public listByUserSchool(){
        return request({
            url: this.url + '/list-by-user-school',
            method: 'get'
        });
    }
    public list(){
        return request({
            url: this.url + '/list',
            method: 'get'
        });
    }
    public listByRole(roleId: number){
        return request({
            url: this.url + '/list-by-role',
            method: 'get',
            params: {schoolId:roleId}
        });
    }
    public add(moduleResource: any){
        return request({
            url: this.url,
            method: 'post',
            data: moduleResource
        });
    }

    public update(moduleResource: any){
        return request({
            url: this.url + "/update-by-id",
            method: 'post',
            data: moduleResource
        });
    }

    public delete(args: any){
        return request({
            url: this.url + "/del-by-id",
            method: 'post',
            data: args
        });
    }
}

class SchoolApi{
    private url: string = service + "/school";
    public get(){
        return request({
            url: this.url,
            method: 'get'
        });
    }
    public getById(schoolId: number){
        return request({
            url: this.url + '/get-by-id',
            method: 'get',
            params: {id:schoolId}
        });
    }
    public tree(){
        return request({
            url: this.url + '/tree',
            method: 'get'
        });
    }
    public treeBySchool(schoolId: number){
        return request({
            url: this.url + '/tree-by-school',
            method: 'get',
            params:{
                schoolId: schoolId
            }
        });
    }
    public listBySchool(schoolId: number,section: number){
        return request({
            url: this.url + '/list-by-parent',
            method: 'get',
            params:{
                schoolId: schoolId,
                sectionId:section
            }
        });
    }
    public disable(schoolId: number){
        return request({
            url: this.url + '/disable',
            method: 'patch',
            data: {id: schoolId}
        });
    }
    public enable(schoolId: number){
        return request({
            url: this.url + '/enable',
            method: 'patch',
            data: {id: schoolId}
        });
    }
    public add(school: any){
        return request({
            url: this.url,
            method: 'post',
            data: school
        });
    }
    public update(school: any){
        return request({
            url: this.url,
            method: 'put',
            data: school
        });
    }
    public delete(id: number){
        return request({
            url: this.url,
            method: 'post',
            data: {id: id}
        });
    }
    /**
     * 保存学校权限
     * @param schoolId 目标学校Id
     * @param rights 要分配给这个学校的权限
     * @param cascade 下级学校是否继承权限。比如：学校2属于学校1，如果为true，则学校2也将拥有学校1的所有权限
     * @param clean 是否清理下级学校的权限。比如：学校2属于学校1，如果为true，则学校2不能有学校1没有的模块和权限
     */
    public saveRights(schoolId: number, rights: any, cascade: boolean, clean: boolean){
        return request({
            url: this.url + '/save-rights',
            method: 'patch',
            data: {
                schoolId: schoolId,
                rights: JSON.stringify(rights),
                cascade: cascade,
                clean: clean
            }
        })
    }
    public moveTo(schoolId: number, toId: number){
        return request({
            url: this.url + '/move',
            method:'patch',
            data:{
                schoolId: schoolId,
                toId: toId
            }
        })
    }

    public schoolConfig(key: string, schoolId: number){
        return request({
            url: this.url + '/get-school-config',
            method:'get',
            params:{
                key: key,
                schoolId : schoolId
            }
        })
    }

    public updateSchoolConfig(key: string, val: any){
        return request({
            url: this.url + '/update-school-config',
            method:'put',
            data: {
                key: key,
                val: val,
            }
        })
    }

    public saveSchoolGrade(args: any){
        return request({
            url: this.url + '/save-school-grade',
            method:'post',
            headers: { 'Content-Type': 'application/json;charset=UTF-8' },
            data: JSON.stringify(args)
        })
    }

    getByName(args: any){
        return request({
            url: this.url + '/get-by-name',
            method:'get',
            params: args
        })
    }
    //查询所有学校
    listSchool(args: any){
        return request({
            url: this.url + '/list-school',
            method:'get',
            params: args
        })
    }


    public updateSchoolDetect(detect: number){
        return request({
            url: this.url + '/update-school-detect',
            method: 'patch',
            data: {detect: detect}
        });
    }
    public getDasicDataCount(){
        return request({
            url: this.url + '/get-basic-data-count',
            method: 'get'
        });
    }
}

class RoleApi{
    private url: string = service + "/role";

    public get(id: number){
        return request({
            url: this.url,
            method: 'get',
            params: {
                id: id
            }
        });
    }

    public list(userType: number ,schoolId: number | undefined){
        return request({
            url: this.url + '/list',
            method: 'get',
            params:{
                userType: userType,
                schoolId: schoolId === undefined ? 0 : schoolId
            }
        });
    }
    public add(role: any){
        return request({
            url: this.url,
            method: 'post',
            data: role
        });
    }

    public update(role: any){
        return requestJson({
            url: this.url,
            method: 'put',
            data: role
        });
    }

    public delete(id: number){
        return request({
            url: this.url + "/del-by-id",
            method: 'post',
            data:{
                id:id
            }
        });
    }

    public listRights(args: number){
        return request({
            url: this.url + '/list-rights',
            method: 'get',
            params: args
        });
    }

    public saveRights(id: number, rights: any){
        return request({
            url: this.url + '/save-rights',
            method: 'post',
            data: {
                id: id,
                rights: rights.join(",")
            }
        })
    }


    public batchEnableOrDisable(roleIds: string, enable: number){
        return request({
            url: this.url + '/batch-enable-or-disable',
            method: 'post',
            data: {
                roleIds: roleIds,
                enable: enable
            }
        })
    }
}

class StudentApi{
    private url: string = service + '/student';
    public copyStudentExamNumber(args: any){
        return request({
            url: this.url + '/copy-student-exam-number',
            method: 'get',
            params: args
        })
    }
    public listStudentByClassId(args: any){
        return request({
            url: this.url + '/list-student-by-classId',
            method: 'get',
            params: args
        })
    }
    public listByEduClass(classId: number){
        return request({
            url: this.url + '/list-student-by-edu-class',
            method: 'get',
            params: {
                classId: classId
            }
        })
    }
    listBySubjectClass(classId: number) {
        return request({
            url: this.url + '/list-student-by-subject-class',
            method: 'get',
            params: {
                classId: classId
            }
        })
    }
    public list(args: any){
        return request({
            url: this.url + '/list',
            method: 'get',
            params: args
        })
    }
    public add(data: any){
        return request({
            url: this.url,
            method: 'post',
            data:data
        })
    }
    public update(data: any){
        return request({
            url: this.url,
            method: 'patch',
            data:data
        })
    }
    public delete(studentId: number){
        return request({
            url: this.url,
            method: 'post',
            data:{
                studentId: studentId
            }
        })
    }

    updateSubjectClasses(studentId: any, classes: any) {
        return request({
            url: this.url + '/update-subject-class',
            method: 'patch',
            data:{
                studentId: studentId,
                subjectClassIds: classes.join(",")
            }
        })
    }


    saveGroup(classId: number, info: string){
        return request({
            url: this.url + '/save-student-group-info',
            method: 'put',
            data:{
                classId: classId,
                studentGroupInfo: info
            }
        })
    }
    updateEduClass(studentId: number, classId: number) {
        return request({
            url: this.url + '/update-edu-class',
            method: 'patch',
            data:{
                studentId: studentId,
                classId: classId
            }
        })
    }

    importStudents(file: string, option: any) {
        return request({
            url: this.url + '/import',
            method: 'patch',
            data:{
                file: file,
                option: option
            }
        })
    }

    public importStudentsNumber(examId: number,file: string, option: any, gradeId: number) {
        return request({
            url: this.url + '/import-student-number',
            method: 'patch',
            data:{
                examId:examId,
                file: file,
                option: option,
                gradeId: gradeId,
            }
        })
    }

    public insertStudentsNumber(args: any) {
        return requestJson({
            url: this.url + '/insert-student-number',
            method: 'patch',
            data:args
        })
    }



    getStudentWithEduClass(data: any){
        return request({
            url: this.url + '/getStudentWithEduClass',
            method: 'get',
            params:data
        })
    }

    getById(id: number){
        return request({
            url: this.url + '/get-student-by-id',
            method: 'get',
            params: {
                id: id
            }
        })
    }
    updateInfoByTeacher(id: number, pwd: string, mobile: string){
        return request({
            url: this.url + '/update-by-teacher',
            method: 'patch',
            data: {
                studentId: id,
                pwd: pwd,
                mobile: mobile
            }
        })
    }
    importGroup(file: string, classId: number){
        return request({
            url: this.url + '/import-student-group',
            method: 'patch',
            data: {
                file: file,
                classId: classId
            }
        })
    }

    getClassBySchoolId(args: any) {
        return request({
            url: this.url + '/get-class-by-schoolId',
            method: 'get',
            params: args
        })
    }
    public exportStudent(args: any){
        return request({
            url: this.url + '/export-student',
            method: 'get',
            params: args
        })
    }

    batchQueryStudentSchool(args: any) {
        return requestJson({
            url: this.url + '/batch-query-student-school',
            method: 'post',
            data: args
        })
    }
}

class DeptApi{
    private url: string = service + '/dept';
    public tree(args: any){
        return request({
            url: this.url + '/tree',
            method: 'get',
            params: args
        })
    }
    public list(){
        return request({
            url: this.url + '/list',
            method: 'get'
        })
    }
    public add(args: any){
        return request({
            url: this.url,
            method: 'post',
            data: args
        });
    }

    public update(args: any){
        return requestJson({
            url: this.url + '/update',
            method: 'patch',
            data: args
        });
    }

    public updateName(id: number, name: string){
        return requestJson({
            url: this.url + '/update-name',
            method: 'patch',
            params: {
                id: id,
                name: name
            }
        });
    }
    public move(id: number,orderId: number){
        return request({
            url: this.url + '/move',
            method: 'get',
            params:{
                id: id,
                orderId: orderId,
            }
        })
    }

    public delete(id: number){
        return request({
            url: this.url + '/del-by-id',
            method: 'post',
            data: {
                id: id
            }
        });
    }
}

class UserApi{
    private url: string = service + '/user';

    public changeUserPwdNotLogin(loginName: string, oldPass: string, newPass: string, captchaId: string, captchaMove: number){
        return request({
            url: this.url + '/change-user-pwd-not-login',
            method: 'post',
            data: {
                loginName: loginName,
                oldPass: oldPass,
                newPass: newPass,
                captchaId: captchaId,
                captchaMove: captchaMove
            }
        });
    }

    public detectAuth(idCard: string, userName: string, idCardUpImage: string){
        return request({
            url: this.url + '/detect-auth',
            method: 'post',
            data: {
                idCard: idCard,
                userName: userName,
                idCardUpImage: idCardUpImage
            }
        });
    }

    public getIdCardInfo(idCardUrl: string, mode: string){
        return request({
            url: this.url + '/get-id-card-info',
            method: 'post',
            data: {
                idCardUrl: idCardUrl,
                mode: mode
            }
        });
    }

    public changeUserMobile(idCard: string, phone: string, token: string, code: string){
        return request({
            url: this.url + '/change-user-mobile',
            method: 'post',
            data: {
                idCard: idCard,
                phone: phone,
                token: token,
                code: code
            }
        })
    }

    public getDetectInfoEnhanced(bizToken: string, mode: string, idCard: string, userName: string, pwd: string, phone: string, idCardUP: string, idCardDown: string){
        return request({
            url: this.url + '/get-detect-info-enhanced',
            method: 'post',
            data: {
                bizToken: bizToken,
                mode: mode,
                idCard: idCard,
                userName: userName,
                pwd: pwd,
                phone: phone,
                idCardUP: idCardUP,
                idCardDown: idCardDown
            }
        });
    }

    public checkIdCardRepeat(idCard: string){
        return request({
            url: this.url + '/check-id-card-repeat',
            method: 'post',
            data: {
                idCard: idCard
            }
        })
    }

    public menus(args: any){
        return request({
            url: this.url + '/menus',
            method: 'get',
            params: args
        });
    }
    public getUserConfig(args: any){
        return request({
            url: this.url + '/get-user-config',
            method: 'get',
            params: args
        });
    }
    public getUserDetail(){
        return request({
            url: this.url + '/get-user-detail',
            method: 'get'
        });
    }
    public deleteUserConfig(args: any){
        return request({
            url: this.url + '/delete-user-config',
            method: 'post',
            data: args
        });
    }
    public updateUserConfig(args: any){
        return requestJson({
            url: this.url + '/update-user-config',
            method: 'post',
            data: args
        });
    }
    public listHaveRightUser(args: any){
        return requestJson({
            url: this.url + '/list-have-right-user',
            method: 'get',
            params: args
        });
    }
    public updateAvatar(path: string){
        return request({
            url: this.url + '/update-avatar',
            method: 'post',
            data: {
                path: path
            }
        });
    }
    public listRoles(userId: number){
        return request({
            url: this.url + '/list-user-roles',
            method: 'get',
            params: {
                userId: userId
            }
        })
    }
    public enable(userId: number){
        return request({
            url: this.url + '/enable',
            method: 'patch',
            params: {
                id: userId
            }
        })
    }
    public disable(userId: number){
        return request({
            url: this.url + '/disable',
            method: 'patch',
            params: {
                id: userId
            }
        })
    }
    public haveRight(right: string){
        return request({
            url: this.url + '/have-right',
            method: 'get',
            params: {
                right: right
            }
        })
    }
    public listUserRights(type: string){
        return request({
            url: this.url + '/list-user-rights',
            method: 'get',
            params: {
                type: type
            }
        })
    }
    public list(args: any){
        return request({
            url: this.url + '/list',
            method: 'get',
            params: args
        })
    }
    public listLoginUsers(args: any){
        return request({
            url: this.url + '/list-login-users',
            method: 'get',
            params: args
        })
    }
    public addOrUpdateUser(args: any){
        return request({
            url: this.url + '/add-or-update-user',
            method: 'post',
            data: args
        })
    }
    public loadDetail(args: any){
        return request({
            url: this.url + '/load-detail',
            method: 'get',
            params: args
        })
    }

    public queryPwd(id: string){
        return request({
            url: this.url + '/query-user-pwd',
            method: 'get',
            params: {
                id: id
            }
        })
    }
    public getOne(args: any){
        return request({
            url: this.url + '/get-one',
            method: 'get',
            params: args
        })
    }
    public delUser(args: any){
        return request({
            url: this.url + '/delete-user',
            method: 'post',
            data: args
        });
    }

    public getOrganizationInfo(){
        return request({
            url: this.url + '/get-organization-info',
            method: 'get',
        })
    }
    public moveToDept(args: any){
        return request({
            url: this.url + '/move-to-dept',
            method: 'post',
            data: args
        })
    }
    public registerUser(args: any){
        return request({
            url: this.url + '/register-user',
            method: 'post',
            data: args
        })
    }
    public unBind(args: any){
        return request({
            url: this.url + '/un-bind',
            method: 'get',
            params: args
        })
    }
    public bind(args: any){
        return request({
            url: this.url + '/bind',
            method: 'get',
            params: args
        })
    }

    public bindOrgPass(orgId: string){
        return request({
            url: this.url + '/bind-org-pass',
            method: 'get',
            params: {
                orgId: orgId
            }
        })
    }




    public passOrNot(args: any){
        return request({
            url: this.url + '/pass-or-not',
            method: 'get',
            params: args
        })
    }
    public bindPassOrNot(args: any){
        return request({
            url: this.url + '/bind-pass-or-not',
            method: 'get',
            params: args
        })
    }
    public changeSelfPassword(args: any){
        return request({
            url: this.url + '/change-self-password',
            method: 'post',
            data: args
        })
    }
    public resetUserPass(args: any){
        return request({
            url: this.url + '/reset-user-pass',
            method: 'get',
            params: args
        })
    }

    public forgetPass(args: any){
        return request({
            url: this.url + '/forget-pass',
            method: 'get',
            params: args
        })
    }
    //设置用户角色
    public setUserRole(args: any){
        return request({
            url: this.url + '/setUserRole',
            method: 'post',
            data: args
        })
    }
    //获取授权码
    public obtainCode(args: any){
        return request({
            url: this.url + '/obtain-code',
            method: 'get',
            params: args
        })
    }
    //用户注册列表
    public registerUserList(args: any){
        return request({
            url: this.url + '/register-user-list',
            method: 'get',
            params: args
        })
    }
    //获取用户列表，包括角色信息
    public listRoleUser(args: any){
        return request({
            url: this.url + '/list-role-user',
            method: 'get',
            params: args
        })
    }
    //按角色批量保存用户
    public saveRoleUser(args: any){
        return request({
            url: this.url + '/save-role-user',
            method: 'post',
            data: args
        })
    }
    // 更新图片
    public updateSignImage(args: any){
        return request({
            url: this.url + '/update-sign-image',
            method: 'post',
            data: args
        })
    }

    batchEditActiveStatus(activeStatus: number, ids: Array<string>){
        return request({
            url: this.url + '/batch-edit-active-status',
            method: 'POST',
            data: {
                activeStatus: activeStatus,
                ids: ids.join(",")
            }
        })
    }
}

class TeacherApi{
    private url: string = service + '/teacher';
    public get(id: number){
        return request({
            url: this.url,
            method: 'get',
            params: {
                id: id
            }
        })
    }
    public list(params: any){
        return request({
            url: this.url + '/list',
            method: 'get',
            params: params
        })
    }
    public listByGroup(groupId: number){
        return request({
            url: this.url + '/list-by-group',
            method: 'get',
            params: {
                groupId: groupId
            }
        })
    }
    public listGroup(){
        return request({
            url: this.url + '/list-group',
            method: 'get'
        })
    }
    public add(params: any){
        return request({
            url: this.url,
            method: 'post',
            data: params
        })
    }
    public update(params: any){
        return request({
            url: this.url,
            method: 'put',
            data: params
        })
    }
    public move(userId: number, deptId: number){
        return request({
            url: this.url + '/move',
            method: 'patch',
            data:{
                userId: userId,
                deptId: deptId
            }
        })
    }
    public delete(userId: number){
        return request({
            url: this.url,
            method: 'post',
            data: {
                id: userId
            }
        })
    }
    public updateTeachInfo(teacherId: number, data: any, leaderGroupIds: any){
        return request({
            url: this.url + '/update-teach-info',
            method: 'patch',
            data:{
                teacherId: teacherId,
                subjectIds: data.subjectIds.join(","),
                gradeIds: data.gradeIds.join(","),
                groupIds: data.groupIds.join(","),
                leaderGroupIds: leaderGroupIds.join(",")
            }
        })
    }
    public updateTeachClasses(teacherId: number, classes: any){
        return request({
            url: this.url + '/update-teach-class',
            method: 'patch',
            data:{
                teacherId: teacherId,
                classIds: classes.join(",")
            }
        })
    }
    public listByGrade(sectionId: number, session: number) {
        return request({
            url: this.url + '/list-by-grade',
            method: 'get',
            params:{
                sectionId: sectionId,
                session: session
            }
        })
    }
    public importTeachers(file: string, option: number){
        return request({
            url: this.url + '/import',
            method: 'patch',
            data:{
                file: file,
                option: option
            }
        })
    }
    public exportTeacher(params: any){
        return request({
            url: this.url + '/export-teacher',
            method: 'get',
            params: params
        })
    }
}

class SubjectGroupApi{
    private url: string = service + '/group';
    public list(schoolId: number, sectionId: number, gradeId: number, subjectId: number){
        return request({
            url: this.url + '/list',
            method: 'get',
            params:{
                schoolId: schoolId,
                sectionId: sectionId,
                gradeId: gradeId,
                subjectId: subjectId
            }
        })
    }
    public listSchoolGroup(schoolId: number){
        return request({
            url: this.url + '/list-by-school',
            method: 'get',
            params:{
                schoolId: schoolId
            }
        })
    }
    public listTeacherGroup(teacherId: number){
        return request({
            url: this.url + '/list-by-teacher',
            method: 'get',
            params:{
                teacherId: teacherId
            }
        })
    }
    public listGrades(groupId: number){
        return request({
            url: this.url + '/list-grades',
            method: 'get',
            params:{
                groupId: groupId
            }
        })
    }
    public add(group: any){
        return request({
            url: this.url,
            method: 'post',
            data: group
        })
    }
    public update(group: any){
        return request({
            url: this.url,
            method: 'put',
            data: group
        })
    }
    public delete(id: number){
        return request({
            url: this.url,
            method: 'post',
            data: {
                id: id
            }
        })
    }
    public updateTeachers(data: any){
        return request({
            url: this.url + '/update-teachers',
            method: 'patch',
            data: data
        })
    }
    public getSubjectGroup(data: any){
        return request({
            url: this.url + '/get-subject-group',
            method: 'get',
            params: data
        })
    }
}

class ClassCategoryApi{
    private url: string = service + '/class-category';
    public listBySchool(){
        return request({
            url: this.url + '/list-by-school',
            method: 'get'
        })
    }
    public add(data: any){
        return request({
            url: this.url,
            method: 'post',
            data: data
        })
    }
    public update(data: any){
        return request({
            url: this.url,
            method: 'patch',
            data: data
        })
    }
    public delete(id: number, force: boolean){
        return request({
            url: this.url,
            method: 'post',
            data: {
                id: id,
                force: force
            }
        })
    }
}
class EduClassApi{
    private url: string = service + '/class';
    public list(params: any){
        return request({
            url: this.url + '/list',
            method: 'get',
            params: params
        })
    }

    public listByTeacherId(teacherId: number){
        return request({
            url: this.url + '/list-by-teacher',
            method: 'get',
            params: {
                teacherId: teacherId
            }
        })
    }
    public listBySchool(schoolId: number){
        return request({
            url: this.url + '/list-by-school',
            method: 'get',
            params: {
                schoolId: schoolId
            }
        })
    }
    public add(data: any){
        return request({
            url: this.url,
            method: 'post',
            data:data
        })
    }
    public update(data: any){
        return request({
            url: this.url,
            method: 'patch',
            data:data
        })
    }

    delete(id: number) {
        return request({
            url: this.url,
            method:'post',
            data:{
                clsId: id
            }
        })
    }
    updateSubjectClasses(id: number, classes: any) {
        return request({
            url: this.url + '/update-subject-class',
            method: 'patch',
            data: {
                classId: id,
                classes: JSON.stringify(classes)
            }
        })
    }

    imports(file: string, replace: number) {
        return request({
            url: this.url + '/import',
            method: 'patch',
            data:{
                file: file,
                replace: replace
            }
        })
    }

    exportClass(params: any) {
        return request({
            url: this.url + '/export-class',
            method: 'get',
            params: params
        })
    }
}
class SubjectClassApi{
    private url: string = service + '/subject-class';
    public list(params: any){
        return request({
            url: this.url + '/list',
            method: 'get',
            params: params
        })
    }
    public listBySchool(schoolId: number){
        return request({
            url: this.url + '/list-by-school',
            method: 'get',
            params: {
                schoolId: schoolId
            }
        })
    }
    public listByTeacher(teacherId: number){
        return request({
            url: this.url + '/list-by-teacher',
            method: 'get',
            params: {
                teacherId: teacherId
            }
        })
    }
    public listTeacherByGradeAndSubject(args: any){
        return request({
            url: this.url + '/list-teacher-by-grade-subject',
            method: 'get',
            params: args
        })
    }
    listByClass(clsId: number) {
        return request({
            url: this.url + '/list-by-class',
            method: 'get',
            params: {
                clsId: clsId
            }
        })
    }
    public add(data: any){
        return request({
            url: this.url,
            method: 'post',
            data:data
        })
    }
    public update(data: any){
        return request({
            url: this.url,
            method: 'patch',
            data:data
        })
    }

    delete(id: number) {
        return request({
            url: this.url,
            method:'post',
            data:{
                clsId: id
            }
        })
    }
    removeStudent(studentId: number, classId: number){
        return request({
            url: this.url + '/remove-student',
            method: 'patch',
            data:{
                studentId: studentId,
                classId: classId
            }
        })
    }

    listByStudent(id: number) {
        return request({
            url: this.url + '/list-by-student',
            method: 'get',
            params:{
                studentId: id
            }
        })
    }

    imports(file: string, replace: number) {
        return request({
            url: this.url + '/import',
            method: 'patch',
            data:{
                file: file,
                replace: replace
            }
        })
    }

    public getSubjectClass(subjectClassId: number){
        return request({
            url: this.url ,
            method: 'get',
            params: {
                subjectClassId: subjectClassId
            }
        })
    }

    //批量设置教师的教师列表，根据年级获取
    listClassInGrade(gradeId: number) {
        return request({
            url: this.url + '/list-class-in-grade',
            method: 'get',
            params:{
                gradeId: gradeId
            }
        })
    }
    //批量设置教师保存
    saveSubjectTeacher(args: any) {
        return requestJson({
            url: this.url + '/save-subject-teacher',
            method: 'post',
            data: args
        })
    }

    //批量设置教师保存
    listSubjectClassBySubjects(args: any) {
        return requestJson({
            url: this.url + '/list-subject-class-by-subjects',
            method: 'post',
            data: args
        })
    }

    //导出教学班
    exportSubjectClass(args: any) {
        return request({
            url: this.url + '/export-subject-class',
            method: 'get',
            params:args
        })
    }
}

class KnowledgeApi {
    private url: string = service + '/knowledge';
    listKnowTree(subjectId: number) {
        return request({
            url: this.url + '/list-tree',
            method: 'get',
            params:{ subjectId: subjectId }
        })
    }

    listKnowledges(args: any) {
        return request({
            url: this.url + '/list-knowledges',
            method: 'get',
            params: args
        })
    }

    //添加知识点
    addKnowledge(args: any) {
        return request({
            url: this.url + '/add-knowledge',
            method: 'patch',
            data: args
        })
    }
    //编辑知识点
    updateKnowledge(args: any) {
        return request({
            url: this.url + '/update-knowledge',
            method: 'patch',
            data: args
        })
    }
    //删除知识点
    delKnowledge(args: any) {
        return request({
            url: this.url + '/del-knowledge',
            method: 'post',
            data: args
        })
    }
}
//章节
class ChapterApi {
    private url: string = service + '/chapter';
    //获取教材版本
    listCoursebookVersion(subjectId: number) {
        return request({
            url: this.url + '/list-coursebook-version',
            method: 'get',
            params:{ subjectId: subjectId }
        })
    }
    //获取教材的册别
    listCoursebookVolume(versionId: number) {
        return request({
            url: this.url + '/list-coursebook-volume',
            method: 'get',
            params:{ versionId: versionId }
        })
    }
    //获取章节树
    listChapterTree(versionId: number,volumeId: number) {
        return request({
            url: this.url + '/list-chapter-tree',
            method: 'get',
            params:{ versionId: versionId, volumeId: volumeId }
        })
    }
    //获取全部章节树
    listVolumeChapterTree(versionId: number) {
        return request({
            url: this.url + '/list-volume-chapter-tree',
            method: 'get',
            params:{ versionId: versionId}
        })
    }
}

//制造单位
class ManufactoryApi {
    private url: string = service + '/manufactory';

    //制造单位列表
    list() {
        return request({
            url: this.url + '/list',
            method: 'get'
        })
    }
    //制造单位分页列表
    page(args: any) {
        return request({
            url: this.url + '/page',
            method: 'get',
            params: args
        })
    }
    //制造单位添加和编辑
    update(args: any) {
        return requestJson({
            url: this.url + '/update',
            method: 'post',
            data: args
        })
    }
    //制造单位删除
    delete(args: any) {
        return request({
            url: this.url + '/delete',
            method: 'post',
            data: args
        })
    }

    //根据code查单位
    getByCreditCode(args: any) {
        return request({
            url: this.url + '/get-by-credit-code',
            method: 'get',
            params: args
        })
    }
}


//计量标准
class MeasuringStandardApi {
    private url: string = service + '/measuring-standard';
    //计量标准列表

    pageV2(args: any) {
        return request({
            url: this.url + '/page-v2',
            method: 'get',
            params: args
        })
    }

    checkEdit(id: number) {
        return request({
            url: this.url + '/check-edit',
            method: 'get',
            params: {
                id: id
            }
        })
    }


    listUnReplaceStandard(args: any){
        return request({
            url: this.url + '/list-un-replace-standard',
            method: 'get',
            params: args
        })
    }

    public pageItemsV2(args: any){
        return request({
            url: this.url + '/page-items-v2',
            method: 'get',
            params: args
        })
    }

    public pageDevicesV2(args: any){
        return request({
            url: this.url + '/page-devices-v2',
            method: 'get',
            params: args
        })
    }

    list(args: any) {
        return request({
            url: this.url + '/page',
            method: 'get',
            params: args
        })
    }
    save(args: any){
        return requestJson({
            url: this.url + '/save-measuring-standard',
            method: 'post',
            data: args
        })
    }

    update(args: any) {
        return requestJson({
            url: this.url + '/update-measuring-standard',
            method: 'post',
            data: args
        })
    }

    updateShare(ids: string, shareStatus: number) {
        return request({
            url: this.url + '/update-share',
            method: 'post',
            data: {
                ids: ids,
                shareStatus: shareStatus,
            }
        })
    }



    getMeasuringStandard(args: any) {
        // return new Promise(resolve => {
        //     axios.get(this.url + '/get-measuring-standard', {
        //         params: args,
        //         transformResponse: [
        //             function (data){
        //                 return data;
        //             }
        //         ]
        //     }).then((data: any) => {
        //         resolve(data);
        //     })
        // })
        return request({
            url: this.url + '/get-measuring-standard',
            method: 'get',
            params: args
        })
    }
    delete(args: any){
        return request({
            url: this.url + '/del-standard',
            method: 'post',
            data: args
        })
    }

    listMeasuringStandardItems(args: any) {
        return request({
            url: this.url + '/list-measuring-standard-items',
            method: 'get',
            params: args
        })
    }

    getMeasuringStandardItems(args: any) {
        return request({
            url: this.url + '/get-measuring-item',
            method: 'get',
            params: args
        })
    }

    listMeasuringStandardByInstrumentId(args: any) {
        return request({
            url: this.url + '/list-measuring-standard-by-instrument-id',
            method: 'get',
            params: args
        })
    }
}


//计量授权证书
class AuthorizeCertApi{
    private url: string = service + '/authorize-cert';
    pageV2(args: any){
        return request({
            url: this.url + '/page-v2',
            method: 'get',
            params: args
        })
    }
    pageItemV2(args: any){
        return request({
            url: this.url + '/page-item-v2',
            method: 'get',
            params: args
        })
    }

    getOrganizationCertCount(){
        return request({
            url: this.url + '/get-organization-cert-count',
            method: 'get',
        })
    }
    getOrganizationCertDetail(args: any){
        return request({
            url: this.url + '/get-organization-cert-detail',
            method: 'get',
            params: args
        })
    }
    list(args: any) {
        return request({
            url: this.url + '/list-organization-cert',
            method: 'get',
            params: args
        })
    }
    saveOrUpdate(args: any){
        return requestJson({
            url: this.url + '/save-or-update-organization-cert',
            method: 'post',
            data: args
        })
    }
    delete(args: any) {
        return request({
            url: this.url + '/delete-organization-cert',
            method: 'post',
            data: args
        })
    }
    updateStatus(args: any) {
        return requestJson({
            url: this.url + '/update-status',
            method: 'PATCH',
            params: args
        })
    }
    listItem(args: any) {
        return request({
            url: this.url + '/list-measuring-items',
            method: 'get',
            params: args
        })
    }
    listItemV2(args: any) {
        return request({
            url: this.url + '/list-measuring-items-v2',
            method: 'get',
            params: args
        })
    }


    regionToAuthorizeCert(args: any){
        return request({
            url: this.url + '/region-to-authorize-cert',
            method: 'post',
            data: args
        })
    }

    updateShare(ids: string, shareStatus: number){
        return request({
            url: this.url + '/update-share',
            method: 'post',
            data: {
                ids: ids,
                shareStatus: shareStatus
            }
        })
    }

    getLastOverdueCert(){
        return request({
            url: this.url + '/get-last-overdue-cert',
            method: 'get',
        })
    }
}

class MenuApi {
    private url: string = service + '/menu';
    tree(args: any) {
        return request({
            url: this.url + '/tree',
            method: 'get',
            params: args
        })
    }

    add(args: any) {
        return requestJson({
            url: this.url + '/add',
            method: 'post',
            data: args
        })
    }


    update(args: any) {
        return requestJson({
            url: this.url + '/update',
            method: 'patch',
            data: args
        })
    }


    delete(args: any) {
        return request({
            url: this.url + '/delete',
            method: 'post',
            data: args
        })
    }

    move(args: any) {
        return request({
            url: this.url + '/move',
            method: 'get',
            params: args
        })
    }



}

class MechanismApi{
    private url: string = service + '/mechanism';
    list(args: any) {
        return request({
            url: this.url + '/list-mechanism-and-user',
            method: 'get',
            params: args
        })
    }
    getMechanismAndUser(orgId: number) {
        return request({
            url: this.url + '/get-mechanism-and-user',
            method: 'get',
            params: {
                organizationId: orgId,
            }
        })
    }
    listMechanismV2(args: any) {
        return request({
            url: this.url + '/list-mechanism-v2',
            method: 'get',
            params: args
        })
    }
    list3(args: any) {
        return request({
            url: this.url + '/list',
            method: 'get',
            params: args
        })
    }
    list2(args: any) {
        return request({
            url: this.url + '/list-mechanism-name',
            method: 'get',
            params: args
        })
    }

    modify(args: any) {
        return requestJson({
            url: this.url + '/modify',
            method: 'patch',
            data: args
        })
    }

    add(args: any) {
        return requestJson({
            url: this.url + '/register-mechanism',
            method: 'post',
            data: args
        })
    }
    add2(args: any) {
        return requestJson({
            url: this.url + '/add',
            method: 'post',
            data: args
        })
    }

    passOrNot(args: any) {
        return request({
            url: this.url + '/pass-or-not',
            method: 'get',
            params: args
        })
    }

    sendVerifyCodeUnVerify(args: any) {
        return request({
            url: this.url + '/send-verify-code-un-verify',
            method: 'get',
            params: args
        })
    }


    sendVerifyCode(args: any) {
        return request({
            url: this.url + '/send-verify-code',
            method: 'get',
            params: args
        })
    }

    checkVerifyUI(args: any) {
        return request({
            url: this.url + '/check-verify-ui',
            method: 'get',
            params: args
        })
    }

    checkOrgNameRepeat(args: any){
        return request({
            url: this.url + '/check-org-name-repeat',
            method: 'post',
            data: args
        })
    }

    checkLoginUserName(args: any) {
        return request({
            url: this.url + '/check-login-user-name',
            method: 'post',
            data: args
        })
    }

    removeMechanism(mode: string, mechanismId: string, code: string){
        return request({
            url: this.url + '/remove-mechanism',
            method: 'get',
            params: {
                mechanismId: mechanismId,
                code: code,
                mode: mode
            }
        })
    }
    batchEditActiveStatus(activeStatus: number, ids: Array<string>){
        return request({
            url: this.url + '/batch-edit-active-status',
            method: 'POST',
            data: {
                activeStatus: activeStatus,
                ids: ids.join(",")
            }
        })
    }

    ocrLicense(path: string, changeApply: boolean){
        return request({
            url: this.url + '/ocr-license',
            method: 'post',
            data:{
                path: path,
                changeApply: changeApply
            }
        })
    }

    ocrSmartStructural(path: string, typeName: string, itemName: string, changeApply: boolean){
        return request({
            url: this.url + '/ocr-smart-structural',
            method: 'post',
            data:{
                path: path,
                itemName: itemName,
                typeName: typeName,
                changeApply: changeApply
            }
        })
    }

    getOrgInfoByCode(code: string, check: boolean){
        return request({
            url: this.url + '/get-org-info-by-code',
            method: 'get',
            params:{
                code: code,
                check: check
            }
        });
    }

    getDetectInfoEnhanced(args: any){
        return requestJson({
            url: this.url + '/get-detect-info-enhanced',
            method: 'post',
            data: args
        })
    }

    getChangeApplyDetectInfo(args: any){
        return requestJson({
            url: this.url + '/get-change-apply-detect-info',
            method: 'post',
            data: args
        })
    }

    pageChangeApply(args: any){
        return request({
            url: this.url + '/page-change-apply',
            method: 'post',
            data: args
        })
    }

    auditChangeApply(args: any){
        return request({
            url: this.url + '/audit-change-apply',
            method: 'post',
            data: args
        })
    }
}
class MechanismNameApi{
    private url: string = service + '/mechanism-name';
    list(args: any) {
        return request({
            url: this.url + '/list',
            method: 'get',
            params: args
        })
    }
    add(args: any) {
        return requestJson({
            url: this.url + '/add',
            method: 'post',
            data: args
        })
    }
    update(args: any) {
        return requestJson({
            url: this.url + '/update',
            method: 'post',
            data: args
        })
    }
    delete(args: any) {
        return request({
            url: this.url + '/delete',
            method: 'post',
            data: args
        })
    }
}

//其他第三方请求API
class QiChaChaApi{
    private url: string = service + '/qichacha';
    selectByCode(args: any) {
        return request({
            url: this.url + '/select-by-code-or-name',
            method: 'get',
            params: args
        })
    }
    listByName(args: any) {
        return request({
            url: this.url + '/list-by-name',
            method: 'get',
            params: args
        })
    }
}

const fileApi = new FileApi();
const ssoApi = new SsoApi();
const moduleApi = new ModuleApi();
const moduleResourceApi = new ModuleResourceApi();
const schoolApi = new SchoolApi();
const studentApi = new StudentApi();
const roleApi = new RoleApi();
const deptApi = new DeptApi();
const dictInstrumentApi = new DictInstrumentApi();
const userApi = new UserApi();
const teacherApi = new TeacherApi();
const dictApi = new DictApi();
const groupApi = new SubjectGroupApi();
const classCategoryApi = new ClassCategoryApi();
const eduClassApi = new EduClassApi();
const subjectClassApi = new SubjectClassApi();
const knowledgeApi = new KnowledgeApi();
const chapterApi = new ChapterApi();
const manufactoryApi = new ManufactoryApi();
const measuringStandardApi = new MeasuringStandardApi();
const menuApi = new MenuApi();
const authorizeCertApi = new AuthorizeCertApi();
const mechanismApi = new MechanismApi();
const qiChaChaApi = new QiChaChaApi();
const mechanismNameApi = new MechanismNameApi();

export {fileApi, ssoApi, subjectClassApi,eduClassApi, groupApi, moduleApi,moduleResourceApi,schoolApi,roleApi,studentApi,deptApi,dictInstrumentApi,userApi,teacherApi,dictApi,classCategoryApi,knowledgeApi,chapterApi,manufactoryApi, measuringStandardApi,menuApi, authorizeCertApi, mechanismApi, qiChaChaApi,mechanismNameApi}
